import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profiletype-management',
  templateUrl: './profiletype-management.component.html',
  styleUrls: ['./profiletype-management.component.scss']
})
export class ProfiletypeManagementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
